module.exports = __webpack_public_path__ + "static/img/activity_entry_point_dh.20ed747e.png";